// src/App.js
import React from "react";
import { Routes, Route } from "react-router-dom";
import ComlinkrLandingPage from "./pages/ComLinkrLandingPage";
import Mission from "./pages/Mission";
import Vision from "./pages/Vision";
import Team from "./pages/Team";
import Founders from "./pages/Founders";
import About from "./pages/About";
import FAQPage from "./pages/FAQPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import DeleteAccount from "./pages/DeleteAccount";
import ChildSafety from "./pages/ChildSafety";
import Support from "./pages/Support";
import Footer from "./pages/Footer";      // adjust if your Footer is in /pages
import "bootstrap/dist/css/bootstrap.min.css";
import ScrollToTop from "./pages/ScrollToTop";  // make sure this doesn't create a Router
import "./pages/LandingPage.css";

function App() {
  return (
    <>
      {/* ensures page scrolls to top on route change */}
      <ScrollToTop />

      <div className="app-shell">
        <main className="app-content">
          <Routes>
            <Route path="/" element={<ComlinkrLandingPage />} />
            <Route path="/mission" element={<Mission />} />
            <Route path="/vision" element={<Vision />} />
            <Route path="/team" element={<Team />} />
            <Route path="/founders" element={<Founders />} />
            <Route path="/about" element={<About />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/delete-account" element={<DeleteAccount />} />
            <Route path="/child-safety" element={<ChildSafety />} />
            <Route path="/support" element={<Support />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </>
  );
}

export default App;
